export const HEALTH_CARD_MENU_ITEM_ID = 'healthCardMenuItem';
